import { getFunctions, httpsCallable } from "firebase/functions";

export const PORTAL_VERIFICATION_EMAIL_RESULT_CODES = Object.freeze({
  SENT: "sent",
});

/**
 * Strict client validator — do not trust generic `{ ok: true }`.
 * @param {unknown} data
 */
export function validatePortalVerificationEmailCallableResponse(data) {
  if (!data || typeof data !== "object") {
    return { valid: false, reason: "invalid_response" };
  }
  if (data.ok !== true) {
    return { valid: false, reason: "not_ok" };
  }
  if (data.resultCode !== PORTAL_VERIFICATION_EMAIL_RESULT_CODES.SENT) {
    return { valid: false, reason: "unexpected_result_code" };
  }
  const retryAfterSeconds = Number(data.retryAfterSeconds);
  if (!Number.isFinite(retryAfterSeconds) || retryAfterSeconds < 60) {
    return { valid: false, reason: "invalid_retry_after" };
  }
  return { valid: true, retryAfterSeconds };
}

export async function sendPortalVerificationEmail(payload = {}) {
  const functions = getFunctions(undefined, "us-central1");
  const fn = httpsCallable(functions, "sendPortalVerificationEmail");
  const result = await fn({
    continueUrl: payload.continueUrl,
    inviteCode: payload.inviteCode || "",
  });
  const validated = validatePortalVerificationEmailCallableResponse(result.data);
  if (!validated.valid) {
    const error = new Error("verification_send_invalid_response");
    error.code = "functions/invalid-response";
    throw error;
  }
  return {
    ok: true,
    resultCode: PORTAL_VERIFICATION_EMAIL_RESULT_CODES.SENT,
    retryAfterSeconds: validated.retryAfterSeconds,
  };
}
